import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=18fc609b"
import script from "./Filtro.vue?vue&type=script&lang=ts"
export * from "./Filtro.vue?vue&type=script&lang=ts"
import style0 from "./Filtro.vue?vue&type=style&index=0&id=18fc609b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports